// External libraries
import gql from 'graphql-tag';

export const CART_OVERCAPTURE_FRAGMENT = gql`
  fragment CartOvercapture on Cart {
    totalAllowedOverCaptureAmount {
      currencyFormatSymbolISOCurrency
    }
  }
`;
